/**
 * @generated SignedSource<<afd4d929e3f0029a668c855a06942649>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment$data = {
  readonly jira: {
    readonly fieldSetViewQueryByProject: {
      readonly __typename: "JiraFieldSetView";
      readonly fieldSets: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_columns">;
      };
    } | {
      readonly __typename: "QueryError";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly issueSearch?: {
      readonly __id: string;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_issues">;
    } | null | undefined;
  };
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_rootRelayFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchinm2performanceisissuesearchapienabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v0/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "fieldSetsInput",
                    "variableName": "fieldSetsInput"
                  },
                  {
                    "kind": "Variable",
                    "name": "issueSearchInput",
                    "variableName": "issueSearchInput"
                  }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_nativeIssueTable_NativeIssueTable_issues"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ]
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "issueKey",
                  "variableName": "issueKey"
                }
              ],
              "kind": "LinkedField",
              "name": "fieldSetViewQueryByProject",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    {
                      "kind": "RequiredField",
                      "field": {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "fieldSetSelectedState": "SELECTED"
                            }
                          },
                          {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "amountOfColumns"
                          }
                        ],
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                          },
                          (v1/*: any*/)
                        ]
                      },
                      "action": "THROW",
                      "path": "jira.fieldSetViewQueryByProject.fieldSets"
                    }
                  ],
                  "type": "JiraFieldSetView"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/)
                  ],
                  "type": "QueryError"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.fieldSetViewQueryByProject"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "b86b6a3046229cdee79af2a372cc5394";

export default node;
